import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
//import { sanitize } from 'dompurify';
import { Modal } from "react-bootstrap";
import GenAIAnsweringPreview from "../Preview/GenAIAnsweringPreview"
import PubMedDisplayStringSup from "./PubMedDisplayStringSup";
import { Link } from "react-router-dom";
import axios from "axios";
import { LocationOrigin, getFormattedAccessGroup } from "../../utils/utilityServices";
import AiNotebookDocumentPreview from "../Preview/AiNotebookDocumentPreview";
import { isEqual } from 'underscore'
import DOMPurify from "dompurify";
import { Authentication } from "../../utils/authenticationUtilityServices";
const sanitize = DOMPurify.sanitize;
let _prodLocationOrigin = "https://ims.jnj.com";
class PubMedDisplayString extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayAns: props.displayAns ? props.displayAns : "",
            sourceNo: props.sourceNo ? props.sourceNo : [],
            pageNumber: props.pageNumber ? props.pageNumber : [],
            Sources: props.sources ? props.sources : [],
            contextIds: props.contextIds ? props.contextIds : [],
            selectedSource: null,
            selectedPageNumber: [],
            showPreviewModel: false,
            isMultiFiles: props.isMultiFiles,
            attachedFiles: props.attachedFiles,
            eventid: props.eventid,
            DisplayString: props.DisplayString ? props.DisplayString : [],
            sourceItem: null,
            searchID: '',
            showAuthoring: false,
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.attachedFiles.length !== this.props.attachedFiles.length) {
            this.setState({ attachedFiles: nextProps.attachedFiles });
        }
        if (!isEqual(this.state.displayAns, nextProps.displayAns)) {
            this.setState({
                displayAns: (nextProps.displayAns) ? nextProps.displayAns : [],
                sourceNo: (nextProps.sourceNo) ? nextProps.sourceNo : [],
                pageNumber: (nextProps.pageNumber) ? nextProps.pageNumber : [],
                Sources: (nextProps.sources) ? nextProps.sources : [],
                DisplayString: (nextProps.DisplayString) ? nextProps.DisplayString : [],
            })
        }
    }
    runSearch = async (PMID) => {
        this.setState({ isPreviewProcessing: true });
        const pmidQueryParams = PMID;
        let newUrl = `/DocURLPubMed?sid=PMS&pmid=${PMID}`;
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
        var url = LocationOrigin + process.env.REACT_APP_IMS_API_PREFIX + 'qp/runSearch'
        if (window.location.origin === "https://predev-ims.jnj.com" ||
            window.location.origin === "https://stage-ims.jnj.com" ||
            window.location.origin === "http://localhost:3000") {
            url = `${_prodLocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}qp/runSearch`;
        }
        var config;
        const _headers = {
            "Content-Type": "application/json"
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                "query": '',
                "boolean": false,
                "filters": '',
                "function": localStorage.getItem('function').replace(/"/g, ''),
                "doctypepref": '',
                "userproducts": localStorage.getItem('userproducts'),
                "region": localStorage.getItem('region'),
                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                "from": 0,
                "size": 25,
                "f1": "pmID",
                "fval1": `${pmidQueryParams}`,
                "fcount": 1,
                accessGroup: getFormattedAccessGroup(userAccessGroup),
                // "source": "searchID"
            }
        }

        await axios(config)
            .then((response) => {
                if (response.data.body.hits.total.value > 0) {
                    if (response.data.body.hits.hits[0]._source) {
                        this.setState({ searchID: response.data.body.hits.hits[0]._source.searchID, sourceItem: response.data.body.hits.hits[0]._source })
                    } else {
                        window.open(newUrl, '_blank')
                        this.setState({ searchID: "", sourceItem: "" })
                    }
                } else {
                    window.open(newUrl, '_blank')
                    this.setState({ searchID: "", sourceItem: "" })
                }
            })
            .catch(function (error) {
                this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");
                //console.log(error);
            })
            .finally(async () => {
                this.setState({ isPreviewProcessing: false });
                // setProcessing(false)
            })

    }
    handlePreviewByPubMedID = async (pmID) => {
        if (pmID) {
            pmID = pmID ? pmID : '-1'
            await this.runSearch(pmID);
            if (this.state.searchID) {
                this.setState({ showAuthoring: true })
            }
        }
    }
    handlePreviewClose = (status) => {
        this.setState({ showAuthoring: false, showPreview: false })
    }
    renderModelPopup = () => {
        let { showPreview, showAuthoring, sourceItem, customWidth } = this.state;
        return (<Modal
            show={(showAuthoring)}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="authoring-popup-transition"
            className="z-index-preview"
            backdropClassName="z-index-preview-backdrop"
            scrollable={false}
        >
            <Modal.Body>
                <div style={{ overflow: "auto" }}>
                    <AiNotebookDocumentPreview customWidth={customWidth} sourceItem={sourceItem} fileName={sourceItem?.fileName} docTitle={sourceItem?.docTitle} searchID={sourceItem?.searchID} searchKeyword={""} synonyms={[]} /*searchID='1a08dc3a4077c024d071f88b33f97c22' */ showPreview={(showAuthoring)} handleClose={this.handlePreviewClose} isOpenAuthoringTab={false} />
                </div>
            </Modal.Body>
        </Modal>)
    }
    renderSourceNo = () => {
        let { sourceNo, Sources, pageNumber, displayAns } = this.state;
        let { sessionID, Question, questionType, threadID } = this.props;
        return (<>
            {sourceNo.map((sitem, dsindex) => {
                let _sourceIndex = Sources.filter(x => x.contexts).findIndex(x => x.contexts.findIndex(y => y.context_id === sitem) !== -1);
                if (_sourceIndex > -1) {
                    let singleSource = Sources.filter(x => x.contexts)[_sourceIndex];
                    let PMID = -1;
                    if (singleSource && singleSource.contexts && singleSource.contexts.length > 0) {
                        PMID = singleSource.contexts[0].pmid;
                    }

                    let url = `/DocURLPubMed?sid=PMS&pmid=${PMID}`;
                    return (
                        <span
                            id="docdata"
                        >
                            <PubMedDisplayStringSup 
                                key={`display-string-${dsindex}`} 
                                singleSource={singleSource} 
                                pageNumber={pageNumber[dsindex]} 
                                //handleClickOnSourceNumber={() => this.handlePreviewByPubMedID(PMID)} sitem={sitem} isMultiFiles={false}
                                sessionID={sessionID} 
                                Question={Question} 
                                questionType={questionType} 
                                threadID={threadID} 
                                sitem={sitem} 
                                selectedTab={this.props.selectedTab}
                                resultListRef = {this.props.resultListRef}
                            />
                        </span>
                    )
                } else {
                    return (
                        <sup key={`display-string-${dsindex}`} className="gen-ai-answering-result-main-answer-sup">{sitem}</sup>
                    )
                }
            })}
        </>)
    }

    renderSourceNoMultiFiles = () => {
        let { sourceNo, Sources, pageNumber, displayAns, contextIds } = this.state;
        return (<>
            {contextIds.map((ctitem, ctindex) => {
                let _sourceIndex = Sources.filter(x => x.contexts).findIndex(x => x.contexts.findIndex(y => y.context_id === ctitem) !== -1);
                if (_sourceIndex > -1) {
                    let singleSource = Sources.filter(x => x.contexts)[_sourceIndex];
                    return (
                        <PubMedDisplayStringSup 
                            key={`display-string-${ctindex}`} 
                            singleSource={singleSource} 
                            pageNumber={pageNumber[ctindex]} 
                            handleClickOnSourceNumber={this.handleClickOnSourceNumber} 
                            sitem={ctitem} 
                            isMultiFiles={true} 
                        />
                    )
                } else {
                    return (
                        <sup key={`display-string-${ctindex}`} className="gen-ai-answering-result-main-answer-sup">{ctitem}</sup>
                    )
                }
            })}
        </>)
    }
    render() {
        
        let { displayAns, isMultiFiles, contextIds } = this.state;
        
        return (<><span dangerouslySetInnerHTML={{ __html: sanitize(`${displayAns}`) }} />
            {/*{(isMultiFiles && contextIds && contextIds.length > 0) && this.renderSourceNoMultiFiles()}*/}
            {(!isMultiFiles) && this.renderSourceNo()}
            <br />
            {this.renderModelPopup()}
        </>
        )
    }
}
export default withRouter(PubMedDisplayString);